const i = (n) => n instanceof File, t = (n) => "id" in n && "file" in n, e = (n) => "id" in n && "path" in n && "size" in n && "type" in n && "filename" in n && "thumbnail" in n;
export {
  e as isFileInfoInterface,
  i as isOsFile,
  t as isOsFileWithId
};
